import { Add, Delete, Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { useDialog, useListItemDeleteApi } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { TmCallResultDialog } from "./TmCallResultDialog";
import { TmCallResultDto } from "./types";

export function TmCallResultListPage() {
    const [useStore] = useState(() => createListStore<TmCallResultDto>({
        path: "settings/tmCallResults",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "code", label: "Code", width: 100 },
            { column: "position", label: "Position", width: 100, type: "number" },
            { column: "isActive", label: "Active?", width: 100, type: "bool" },
            { column: "name", label: "Name", flex: 1 },
        ],
    }));

    const { selectedItem } = useStore(p => ({ selectedItem: p.selectedItem }));
    const editDialog = useDialog(close => <TmCallResultDialog close={close} tmCallResult={selectedItem!} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    const newDialog = useDialog(close => <TmCallResultDialog close={close} tmCallResult={null} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    const deleteItem = useListItemDeleteApi<TmCallResultDto>(useStore, item => "settings/tmCallResults/" + item.id);
    return <>
        {editDialog.render()}
        {newDialog.render()}
        {deleteItem.dialog.render()}
        <PageTitle title="TM call results" />
        {renderListStore(useStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={selectedItem == null} title="Delete" onClick={() => deleteItem.showDialog()}><Delete /></Button>],
            ]),
        })}
    </>;
}
